import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useSelector } from '@tmapy/redux';
import { getAttributions } from './utils';
export const Attributions = React.memo(() => {
    const layers = useSelector((state) => state.mapCore.layers);
    const visibleAttributions = useMemo(() => {
        return getAttributions(layers);
    }, [layers]);
    return _jsx(_Fragment, { children: visibleAttributions.join(', ') });
});
//# sourceMappingURL=Attributions.js.map